module.exports = __webpack_public_path__ + "img/icon_L3.fdf8ad70.png";